<template>
  <div class="public-map">
    <help-public v-bind:lang="filters.lang" v-bind:instance="filters.city" v-bind:enabledHelp="enabledHelp" v-bind:groupEntrave="groupEntrave" v-bind:openLegend="openLegend" ></help-public>
    <div id="map" class="full-screen-map">
      <div v-show="loading" class="loading-map">
        <img src="../../public/img/loading.gif" />
      </div>
    </div>
    <!--
      <div class="col-sm-6 col-md-6 col-lg-6 filters-step-element">
        <base-switch v-model="filters.step1" on-text="" off-text=""></base-switch><span class="step-title">{{ $t('publicPage.filterStep1') }}</span>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-6 filters-step-element">
        <base-switch v-model="filters.step2" on-text="" off-text=""></base-switch><span class="step-title">{{ $t('publicPage.filterStep2') }}</span>
      </div>
    -->
    <div v-if="filters.city!='gatineau'" v-show="enabledHelp" class="col-sm-12 col-md-12 col-lg-12 public-filters-content">
      <!--<div v-show="filterStep" class="col-sm-2 col-md-2 col-lg-2 filters-step-container">-->
      <div v-show="filterStep" class="filters-step-container">
        <div class="filters-step-content">
          <div class="dropdown show-dropdown dropup" :class="{ show: displayType }"  @mouseover="displayType = true" @mouseleave="displayType = false">
            <a data-toggle="dropdown" class="settings-icon">
              <!--<i class="fas map-icons list-icon"></i>-->
              <i class="tim-icons icon-bullet-list-67"></i>
            </a>
            <div class="dropdown-menu" :class="{ show: displayType }">
              <label class="dropdown-title">{{ $t('publicPage.title') }}</label>
              <div v-show="filters.step2" class="divider"></div>
              <div class="filters-step-element">
                <base-switch v-model="filters.step2" on-text="" off-text=""></base-switch><span class="step-title">{{ $t('publicPage.filterStep2') }}</span>
              </div>
              <div class="filters-step-element">
                <base-switch v-model="filters.step1" on-text="" off-text=""></base-switch><span class="step-title">{{ $t('publicPage.filterStep1') }}</span>
              </div>
              <div v-if="filters.city == 'guelph'" class="filters-step-element">
                <base-switch v-model="filters.emergencyProject" on-text="" off-text=""></base-switch><span class="step-title">{{ $t('publicPage.filterEmergencyProject') }}</span>
              </div>
              <div class="filters-step-element">
                <base-switch v-model="filters.year" on-text="" off-text=""></base-switch><span class="step-title">{{ $t('publicPage.filterYear') }} {{year}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--
      <div class="col-sm-2 col-md-2 col-lg-2">
      </div>
      -->
      <!--<div class="col-sm-6 col-md-6 col-lg-6 filters-range">-->
      <div v-show="enabledHelp" class="filters-range">
        <base-input>
          <el-date-picker
            type="datetimerange"
            value-format="timestamp"
            range-separator="-"
            format="yyyy-MM-dd HH:mm"
            lang="fr"
            :clearable="false"
            v-bind:start-placeholder="$t('projectForm.labelProjectStart')"
            v-bind:end-placeholder="$t('projectForm.labelProjectEnd')"
            v-model="filters.ranges">
          </el-date-picker>
        </base-input>
      </div>
    </div>
  </div>
</template>
<script>

import {TimeSelect, DatePicker} from 'element-ui';
import {BaseSwitch} from 'src/components/index';
import axios from 'axios';
import { loadModules } from 'esri-loader';
import colors from './../app/shared/colors';
import icons from './../app/shared/icons';
import RoadNetwork from './../app/shared/roadNetwork';
import Tags from './../app/shared/filters';
import HelpersMaps from './../app/helpers/helpersMap';
import HelpersDrawProject from './../app/helpers/helpersDrawProject';
import MapColors from './../app/helpers/mapColors';
import createSearch from './../app/helpers/searchWidget';
import features from './../app/shared/features';
import HelpPublic from './HelpPublic.vue';
import ProjectsTimeline from  './../app/map/TimelineProjectsComponent.vue';
import moment from 'moment';

const maxSlices = 60;

export default {
  components: {
    BaseSwitch,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    HelpPublic
  },
  data() {
    return {
      year: new Date().getFullYear(),
      displayType: false,
      loading: true,
      groupEntrave: true,
      enabledHelp: false,
      openLegend: false,
      display: {
        'entraves': false,
        'closing': false,
        'detours': false
      },
      colors: colors.list,
      icons: icons,
      user: null,
      pinLayer: null,
      geometryEngine: null,
      webMercatorUtils: null,
      geodesicUtils: null,
      GraphicsLayer: null,
      entravesLayer: null,
      detoursLayer: null,
      closingLayer: null,
      phasesLayer: null,
      Graphic  : null,
      Polyline : null,
      Point: null,
      filterStep: false,
      onAuto: false,
      filters:  {
        long: -123.07931356264523,
        lat: 49.24675853467655,
        type: 'osm',
        publish: true,
        nopublish: true,
        ranges: [],
        city: 'vancouver',
        tags: {},
        step1: true,
        step2: true,
        emergencyProject: true,
        auto: false,
        pieton: false,
        cycliste: false,
        year: false,
        addressLayer: undefined
      },
      projects: [],
      graphics: {},
      refs: [],
      proNames: [],
      zoom: 15,
      Polygon: null,
          };
  },
  watch: {
    'filters.ranges'(val) {
      if (this.loading) {
        return;
      }
      //this.filters.ranges=val;
      if (this.filters.tags.step.length==0) {
        delete this.filters.tags.step;
      }
      this.resetLayer();
      this.getProjects();
    },
    'filters.step1'(val) {
      this.updateStepTags();
    },
    'filters.step2'(val) {
      if (!val) {
        this.filters.auto=false;
        this.filters.cycliste=false;
        this.filters.pieton=false;
      }
      this.updateStepTags();
    },
    'filters.emergencyProject'(val) {
      this.updateStepTags();
    },
    'filters.year'(val) {
      if (val) {
        let year = new Date().getFullYear();
        this.filters.ranges=[new Date(year + '-01-01').getTime(), new Date(year + '-12-31').getTime()];
      } else {
        this.filters.ranges=[];
      }
    }/*,
    'onAuto'(val) {
      this.filters.auto=val;
      this.resetLayer();
      this.getProjects();
    }*/
  },
  created() {
    this.user=JSON.parse(window.localStorage.getItem('user'));
    if (this.$route.query) {
      this.filters.long = parseFloat(this.$route.query.long, 10);
      this.filters.lat = parseFloat(this.$route.query.lat, 10);
      this.filters.city = this.$route.query.city || 'quebec';
      this.filters.type = this.$route.query.type || 'osm';
      this.filters.modeMap = this.$route.query.modeMap || '0';
      this.filters.lang = this.$route.query.lang || 'fr';
      this.$root.$i18n.locale = this.filters.lang;
      if (this.$route.query.uuid) {
        this.enabledHelp=false;
        this.filters.uuid = this.$route.query.uuid;
        this.filters.close = this.$route.query.close;
        this.zoom = this.$route.query.zoom || 15;
        if (this.$route.query.addressLayer !== undefined && this.$route.query.addressLayer !== "") {
          this.filters.addressLayer = this.$route.query.addressLayer === 'true';
        }
        if (this.$route.query.phases) {
          this.filters.phases = this.$route.query.phases;
        } else {
          this.filters.phases = 'all';
        }
      } else {
        this.enabledHelp=true;
        this.openLegend = window.innerWidth > 768;
        let sdate = new Date().getTime() - (6*30*24*60*60*1000);
        let edate = new Date().getTime() + (6*30*24*60*60*1000);
        this.filters.publish = this.$route.query.publish || true;
        this.filters.nopublish = this.$route.query.nopublish || false;
        this.filters.ranges = [parseInt(this.$route.query.sdate, 10) || sdate, parseInt(this.$route.query.edate, 10) || edate];
        //this.display.entraves = JSON.parse(this.$route.query.entraves) || false;
        this.display.entraves = (this.$route.query.entraves==='true') || false;
        //this.display.closing  =  JSON.parse(this.$route.query.closing) || false;
        this.display.closing  =  (this.$route.query.closing==='true') || false;
        //this.display.detours  =  JSON.parse(this.$route.query.detours) || false;
        this.display.detours  =  (this.$route.query.detours==='true') || false;
      }
      this.filters.tags.step=[];
      Tags[this.filters.city].step.value.forEach(element => {
        if((element.value!='7') && (element.value!='8')) {
          this.filters.tags.step.push(element.value);    
        }
      });
    } 
  },
  mounted() {
    loadModules(["esri/Map",
    "esri/Basemap",
    "esri/views/MapView",
    "esri/layers/FeatureLayer",
    "esri/layers/GraphicsLayer",
    "esri/Graphic",
    "esri/geometry/Polyline",
    "esri/geometry/Point",
    "esri/geometry/geometryEngine",
    "esri/geometry/support/geodesicUtils",
    "esri/geometry/support/webMercatorUtils",
    "esri/layers/VectorTileLayer",
    "esri/config",
    "esri/geometry/Polygon",
    "esri/layers/support/LabelClass",
    "esri/renderers/SimpleRenderer",
    "esri/symbols/TextSymbol",
    "esri/symbols/SimpleMarkerSymbol",
    ]).then(([Map, BaseMap, MapView, FeatureLayer, GraphicsLayer, Graphic, Polyline, Point, geometryEngine, geodesicUtils, webMercatorUtils, VectorTileLayer,EsriConfig,Polygon,LabelClass,SimpleRenderer,TextSymbol,SimpleMarkerSymbol]) => {
        let location = [this.filters.long, this.filters.lat];
        EsriConfig.apiKey = process.env.VUE_APP_ARCGIS_API_KEY; 
        let type = this.filters.type || 'osm';
        var basemap;
        if (this.filters.type && this.filters.modeMap==="1") {
          basemap = new BaseMap({
            portalItem: {id: this.filters.type}
          });
        }
        else if (this.filters.type && this.filters.modeMap==="2"){
          basemap = new BaseMap({
            baseLayers: [
              new VectorTileLayer({
                portalItem: {
                  id: this.filters.type
                }
              })
            ]
          });
        } 
        else {
          basemap = this.filters.type || 'osm'; 
        }
        this.map = new Map({
          basemap: basemap
        });
        /*
        this.map = new Map({
          basemap : type
        });
        */
        this.view = new MapView({
          container: "map",
          map: this.map,
          center: location,
          zoom: this.zoom,
          spatialReference: 102100,
          highlightOptions: {
            color: [255, 255, 255, 0],
            haloOpacity: 0,
            fillOpacity: 0
          }
        });
        this.view.ui.move("zoom", "top-left");
        this.layerStreets = new FeatureLayer({
          url : RoadNetwork[this.filters.city].url,
          visible : false,
          outFields: RoadNetwork[this.filters.city].fields
        });
        const cityFeatures = features[this.filters.city] || {};
        if (cityFeatures.publicMapSearch && cityFeatures.publicMapSearch.show && !this.filters.uuid) {
          loadModules(["esri/widgets/Search", "esri/tasks/Locator"]).then(([Search, Locator]) => {
            this.view.ui.add(createSearch(Search, Locator, {
              view: this.view,
              searchSource: cityFeatures.searchSource,
              placeholder: this.$t('mapPage.serchePlaceHolder'),
              streetsLayer: this.layerStreets,
              streets: RoadNetwork[this.filters.city]
            }), { position: "top-left", index: 0 });
          });
        }
        let _this=this;
        
        this.view.popup.on("trigger-action", function(evt){
          if (evt.action.id==='public-project-info') _this.activeAnimation(evt.action.uuid);
        });

        this.groupEntrave=RoadNetwork[this.filters.city].groupEntrave;
        this.filterStep = Tags[this.filters.city].step.show;

        this.Graphic = Graphic;
        this.Polyline = Polyline;
        this.Point = Point;
        this.webMercatorUtils = webMercatorUtils;
        this.geodesicUtils = geodesicUtils;
        this.geometryEngine = geometryEngine;
        this.Polygon = Polygon;
        this.pinLayer    = new GraphicsLayer();
        this.map.add(this.pinLayer);
        this.entravesLayer = new GraphicsLayer();
        this.map.add(this.entravesLayer);
        this.closingLayer = new GraphicsLayer();
        this.map.add(this.closingLayer);
        this.phasesLayer = new GraphicsLayer();
        this.map.add(this.phasesLayer);
        this.detourLayer = new GraphicsLayer();
        this.map.add(this.detourLayer);
        try {
          if(this.filters.city==="magog"){
            const addressLabelClass = new LabelClass({
              labelExpressionInfo: {
                expression: "$feature.CiviqueInf"
              },
              symbol: new TextSymbol({
                color: "black",
                haloColor: "white",
                haloSize: "1px",
                font: {
                  size: 10,
                  weight: "bold",
                  family: "Arial"
                }
              }),
            });
            const streetLabelClass = new LabelClass({
              labelExpressionInfo: {
                expression: "$feature.ANNOTATION"
              },
              symbol: new TextSymbol({
                color: "black",
                haloColor: "white",
                haloSize: "1px",
                font: {
                  size: 10,
                  weight: "bold",
                  family: "Arial"
                }
              }),
            });
            const invisiblePointRenderer = new SimpleRenderer({
              symbol: new SimpleMarkerSymbol({
                size: 0
              })
            });
            this.view.popup.visible = false;
            let showAddressLayer = false;
            let showStreetLayer = true;

            if (this.filters.addressLayer !== undefined) {
              showAddressLayer = this.filters.addressLayer;
              showStreetLayer = this.filters.addressLayer;
            } else {
              if (this.filters.uuid && this.filters.phases) {
                showAddressLayer = true;
              }
            }

            let layerAddress = new FeatureLayer({
              url: "https://services7.arcgis.com/Jv5Zt4NwNN3D7R2S/arcgis/rest/services/Couches_InfoTravaux/FeatureServer/0",
              labelingInfo: [addressLabelClass],
              renderer: invisiblePointRenderer,
              visible : showAddressLayer,
            });
            this.map.add(layerAddress);
            let layerStreetName = new FeatureLayer({
              url: "https://services7.arcgis.com/Jv5Zt4NwNN3D7R2S/arcgis/rest/services/Couches_InfoTravaux/FeatureServer/1",
              labelingInfo: [streetLabelClass],
              renderer: invisiblePointRenderer,
              visible : showStreetLayer,
            });
            this.map.add(layerStreetName);
          }
        } catch (error) {
          console.error("Error ", error);
        }

        this.getProjects();
        
    }).catch(() => {
      //console.error(err);
    });
  },
  methods: {
    resetLayer() {
      this.projects=[];
      this.pinLayer && this.pinLayer.removeAll();
      this.entravesLayer && this.entravesLayer.removeAll();
      this.closingLayer && this.closingLayer.removeAll();
      this.phasesLayer && this.phasesLayer.removeAll();
      this.detourLayer && this.detourLayer.removeAll();
      this.refs.forEach(element => {
        clearInterval(element);
      });
      this.refs=[];
    },
    updateStepTags() {
      let tags = [];
      if (this.filters.step1) tags = tags.concat(this.getUpcomingSteps());
      if (this.filters.step2) tags = tags.concat(this.getInProgressSteps());
      if (this.filters.city === 'guelph' && this.filters.emergencyProject) {
        tags.push('9');
        tags.push('10');
      }
      
      this.filters.tags.step = tags;
      this.resetLayer();
      if (this.filters.tags.step.length > 0) {
        this.getProjects();
      }
    },
    getInProgressSteps() {
      const city = this.filters.city;
      const inProgressMap = {
        'brossard': ['6', '9'],
        'montroyal': ['2', '9', '10'],
        'vd': ['2', '9'],
        'mascouche': ['2', '3', '4']
      };
      return inProgressMap[city] || ['2'];
    },
    getUpcomingSteps() {
      const city = this.filters.city;
      const upcomingMap = {
        'brossard': ['1', '2', '3', '4', '5'],
        'gatineau': ['1', '4'],
        'vd': ['1', '3', '4', '5']
      };
      return upcomingMap[city] || ['1'];
    },
    /*getColorByEntity(project, defaultColor) {
      let color;
      let _this=this;
      if (project && project.informations && project.informations.entity) {
        let len = project.informations.entity.length;
        let entity=project.informations.entity[len-1];
        let entities = Tags[this.filters.city].entity.value;
        entities.forEach((element) => {
          if ((element.value==entity) && (element.class)) {
            let classes = Tags[_this.filters.city].entity.classes;
            color = classes[element.class] || defaultColor;
          }
        });
      }
      if (color) {
        return color;
      } else {
        return defaultColor;
      }
    },*/
    changeAuto(target) {
      this.resetLayer();
      this.getProjects();
    },
    async getProjects() {
      this.loading = true;
      try {
          const response = await axios.post('public/get_projects', this.filters);
          let data = response.data;
          if (data.success) {
            let projectsData = Array.isArray(data.data) ? data.data : [data.data];
            let uuids = [];
            for (const element of projectsData) {
                try {
                    if (this.checkAuto(element)) {
                        this.projects[element.data.uuid] = element.data;
                        // Fetch archive data for each project
                        uuids.push(element.data.uuid);
                    }
                  
                } catch (error) {
                    console.error("Error At checkAuto or fetching archives!: ", error);
                }
            }
            if (uuids.length > 0) {
              await this.fetchArchives(uuids);
            }
            if (this.filters.uuid && this.filters.phases) {
              this.projectsPins = [];
              try {
                this.drawProjectPin(this.projects[this.filters.uuid], '#5291d6');
              } catch (error) {
                console.log("Error At drawProjectPin!: ", error);
              }
              this.drawPhases();
              // this.view.goTo(this.pinLayer.graphics.toArray());
              } else {
              this.drawProjects();
            }
          } else {
              if (data.need_auth) {
                  this.$router.push({ path: '/login' });
              } else {
                  this.$notify({
                      message: this.$i18n.t('serverReply.errorProject'),
                      timeout: 30000,
                      icon: 'tim-icons icon-bell-55',
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                  });
              }
          }
        } catch (error) {
            console.error("Error loading project: ", error);
            // Handle errors that occur during the HTTP request
        } finally {
            this.loading = false;
        }
      },

      async fetchArchives(uuids) {
        try {
          const archiveResponse = await axios.post('public/archivefilterlist', {"filterlist": uuids });
          let archiveData = archiveResponse.data;
          if (archiveData.success) {
            archiveData.archives.forEach(archive => {
              if (this.projects[archive.project]) {
                if (!this.projects[archive.project]["archives"]) {
                  this.projects[archive.project]["archives"] = [];
                }
                this.projects[archive.project]["archives"].push(archive);
              }
            });
          }

        } catch (error) {
          console.error("Failed to fetch  archives: ", error);
        }
      },
    checkAuto(element) {
      
      let project = element.data;
      if ((!this.filters.auto) && (!this.filters.cycliste) && (!this.filters.pieton)) {
        return true;
      } else {
        let checkAuto=true;
        if (project.informations && project.informations.passanger && 
            (project.informations.passanger.value[1] && (project.informations.passanger.value[1].status==true && this.filters.auto==true)) || 
            (project.informations.passanger.value[2] && (project.informations.passanger.value[2].status==true && this.filters.cycliste==true)) ||
            (project.informations.passanger.value[3] && (project.informations.passanger.value[3].status==true && this.filters.pieton==true))) {
          project.phases.forEach((phase) => {
            phase.closing.forEach((close) => {
              if (close.detours.length > 0) {
                checkAuto=true;
              }  else {
                checkAuto=false;
              }
            });
          });
        } else {
          checkAuto=false;
        }
        return checkAuto;
      }
    },
    drawProjects() {
      let _this = this;
      let keys = Object.keys(this.projects);
      this.projectsPins = [];
      keys.forEach(function(element, index) {
        try {
          let defaultColor = _this.colors[index % keys.length];
          let iconColor = MapColors.entityColor(_this.projects[element], _this.filters.city, defaultColor, true);
          let color = MapColors.projectColor(_this.projects[element], _this.filters.city, defaultColor, true);
          _this.drawProjectPin(_this.projects[element], iconColor);
          _this.drawProjectEntraves(_this.projects[element], color, iconColor);
          if(_this.projects[element].informations.publicMapWork){
            _this.drawProjectPhases(_this.projects[element], color, iconColor);
          }
          //_this.view.goTo(_this.pinLayer.graphics.toArray());
        } catch (error) {
          console.log("Error At drawProjects!: ", error);
        }
      });
      _this.view.goTo(_this.pinLayer.graphics.toArray());
    },
    drawProjectPin(project, color) {
      project.reportInfos=this.reportInfos(project.informations, this.filters.lang);
      project.lang=this.filters.lang;
      project.city=this.filters.city;
      let graph = HelpersDrawProject.drawPin(project,this.Point, this.Polyline,this.Graphic, this.geometryEngine, this.webMercatorUtils, color,true,Tags[this.filters.city],this.filters.city, this.Polygon);
      let geographic = this.webMercatorUtils.webMercatorToGeographic(graph.geometry);
      let converted = turf.point([geographic.longitude, geographic.latitude]);
      this.projectsPins.push({"x" : converted.geometry.coordinates[0], "y" : converted.geometry.coordinates[1]});
      this.pinLayer.add(graph);
    },
    drawProjectEntraves(project, color, iconColor = color) {
      let _this=this;
      if (_this.display.entraves) {
        project.entraves.entraves.forEach((entrave) => {
          if (entrave.type=='linear') {
            _this.drawEntravePolyline(entrave, {}, 'entrave', color);
          }if (entrave.type=='polygon') {
            _this.drawEntravePolygone(entrave, {}, 'entrave', color);
          } else {
            //_this.drawPoint(entrave, {}, 'entrave', color);
            -this.drawEntravesPoint(entrave.selected.path[0], 'entrave', iconColor);
          }
        });
      }
    },
    drawProjectPhases(project, color, iconColor = color) {
      let _this=this;
      project.phases.forEach((phase, phaseIndex) => {
        phase.closing.forEach((close, closeIndex) => {
          if (_this.display.closing && (close.publish!=undefined && (close.publish==true) && ((project.informations.publicMapWork && project.informations.publicMapWork!=undefined && project.informations.publicMapWork==true)))) {
            if (close.type=='linear') {
              let pinCloseGraph = _this.drawPinLinearClose(close, phaseIndex+1, closeIndex+1, iconColor);
              let obj = {pUUID: project.uuid, elementId: close.closingId, type: 'linear', entry: 'closing', pinCloseGraph: pinCloseGraph, color: color};
              //_this.drawProjectsClosingPolyline(close, obj, 'closing', color);
              if (_this.filters.uuid) {
                _this.drawProjectsClosingPolyline(close, obj, 'closing', color);
              } else {
                _this.drawEntravePolyline(close, obj, 'closing', color);
                _this.closingLayer.add(obj.pinCloseGraph);
              }
            } else {
              let typeClosing = close.dates[0].closingType[0] || 'complete';
              let obj = {pUUID: project.uuid, elementId: close.closingId, type: 'ponctuel', entry: 'closing', typeClosing: typeClosing, color: iconColor};
              obj.closingPointPopupTemplate = _this.populatePopup(close, phaseIndex+1, closeIndex+1);
              _this.drawProjectsClosingPoint(close.selected.path[0], obj, 'closing', iconColor);
            }
            if (_this.display.detours) {
              _this.drawDetours(project.uuid, close, MapColors.detourColor(_this.filters.city, color), phaseIndex, closeIndex);
            }
          }
        });
      });
    },
    drawDetours(pUUID, close, color, phaseIndex, closeIndex) {
      let _this=this;
      close.detours.forEach(function(detour,detourIndex) {
        let obj = {pUUID: pUUID, elementId: detour.detourId, type: 'linear', entry: 'detour', color: color,  phaseIndex:phaseIndex+1, closeIndex:closeIndex+1, detourIndex:detourIndex+1};
        _this.drawProjectsDetourPolyline(detour, obj, 'detour', color );
        //_this.drawAnimateDetour(pUUID, detour.detourId, obj);
      });
    },
    drawEntravePolyline(paths, obj, type, color) {
      let _this = this;
      let polyline = HelpersMaps.updateSimpleLine(paths, this.Point, this.Polyline, this.geometryEngine);
      let graph = new _this.Graphic({
        geometry   : polyline,
        //attributes : paths[0].attributes,
        visible : true,
        symbol : {
          type: 'simple-line',
          style: 'solid',
          color: color,
          width: '2px'
        },
      });
      let graphs = [graph];
      graphs.forEach((g) => {
        _this.entravesLayer.add(g);
      });
    },
    drawEntravePolygone(paths, obj, type, color) {
      let _this = this;
      paths.selected.path.forEach(graphicJSON => {
        let graphic = _this.Graphic.fromJSON(graphicJSON);
        let fillColor = HelpersMaps.hexToRgba(color, 0.3);

        if (graphicJSON.geometry && graphicJSON.geometry.paths) {
          graphic.symbol = {
            type: "simple-line",
            style: "solid",
            color: color,
            width: "2px"
          };
        } else {
          graphic.symbol = {
            type: "simple-fill",
            color: fillColor,
            style: "solid",
            outline: {
              type: "simple-line",
              color: color,
              width: "2px"
            }
          };
        }
        _this.entravesLayer.add(graphic);
      });
    },
    drawEntravesPoint(point, type, color) {
      let graph = HelpersDrawProject.drawPoint(point, this.Graphic, type, color, this.Point);
      this.entravesLayer.add(graph);
    },
    populatePopupDetour(detour, phaseIndex, closeIndex,detourIndex) {
      let content = "";
      detour.dates.forEach((element,index) => {
        content += '<strong>' + this.$i18n.t('projectForm.labelProjectPeriod') +'#' + (index+1) + ': </strong>';
        let sdate = this.formatDate(element.sdate);
        let edate = this.formatDate(element.edate);
        content += '<span>' + sdate + '</span> - <span>' + edate +'</span><br/>';
      });

      let popupTemplate = {
        title: (this.$i18n.t('mapPage.phase') + phaseIndex) + ' ' + (this.$i18n.t('mapPage.closing') + closeIndex + ' ' + (this.$i18n.t('mapPage.detours') + detourIndex)),
        content: content
      };
      return popupTemplate;
    },
    drawProjectsDetourPolyline(paths, obj, type, color) {
      let _this = this;
      let detourSensValue = paths.dates[0].detourSensValue;
      let polyline = HelpersMaps.updateSimpleLine(paths, this.Point, this.Polyline, this.geometryEngine);
      let graphs = HelpersMaps.drawRepeated(polyline, color, type, this.Polyline, this.Point, this.Graphic, this.geometryEngine, this.webMercatorUtils, this.geodesicUtils, detourSensValue);
      _this.populateGraph(obj, graphs);
      graphs.forEach((g) => {
        if(obj.phaseIndex){
          let popupTemplate = this.populatePopupDetour(paths, obj.phaseIndex, obj.closeIndex, obj.detourIndex);
          g.popupTemplate = popupTemplate;
        }
        _this.detourLayer.add(g);
      });
    },
    drawProjectsClosingPolyline(paths, obj, type, color) {
      let _this = this;
      let polyline = HelpersMaps.updateSimpleLine(paths, this.Point, this.Polyline, this.geometryEngine);
      let graphs = HelpersMaps.drawRepeated(polyline, color, type, this.Polyline, this.Point, this.Graphic, this.geometryEngine, this.webMercatorUtils, this.geodesicUtils);
      graphs.forEach((g) => {
        _this.closingLayer.add(g);
      });
      _this.closingLayer.add(obj.pinCloseGraph);
    },
    drawProjectsClosingPoint(point, obj, type, color) {
      let graph = HelpersDrawProject.drawPoint(point, this.Graphic, type, color, this.Point, obj.typeClosing);
      graph.popupTemplate = obj.closingPointPopupTemplate;
      this.closingLayer.add(graph);
    },
    drawPhases() {
      let defaultColor = this.colors[0];
      this.display.entraves =  true;
      let project = this.projects[this.filters.uuid];
      let color = MapColors.projectColor(project, this.filters.city, defaultColor, true);
      // Cities with a mapColorBy mode paint closures/detours like the overview map; others keep the legacy red/cyan notice colors.
      let colorMode = MapColors.mode(this.filters.city);
      let glyphColor = 'rgba(240,51,47,0.5)';
      let closeColor = colorMode ? color : glyphColor;
      let detourColor = colorMode ? MapColors.detourColor(this.filters.city, color) : 'rgba(0,209,211,0.7)';
      this.drawProjectEntraves(project, color);
      let _this=this;

      if(project.phases.length > 0){

        project.phases.forEach((phase, index) => {
          try {
            if ((_this.filters.phases=='all') || (phase.phaseId==_this.filters.phases)) {
              if(_this.filters.close && _this.filters.close!='' && _this.filters.close!='all' && _this.filters.close!=undefined && _this.filters.close!='undefined') {
                phase.closing.forEach((close, closeIndex) => {
                  if(close.closingId==_this.filters.close) {
                    _this.drawCloses(close, closeIndex, index, closeColor, detourColor, glyphColor);
                  }
                });
              } else {
                phase.closing.forEach((close, closeIndex) => {
                  _this.drawCloses(close, closeIndex, index, closeColor, detourColor, glyphColor);
                });
              }
              _this.view.goTo(_this.phasesLayer.graphics.toArray());
            }
          } catch (error) {
            console.log("Error At drawPhases!: ", error);
          }
        });

        if(_this.$route.query.phases!='' ){
          const graphics = this.phasesLayer.graphics.toArray();
          const validGraphics = graphics.filter(graphic => graphic.geometry && graphic.geometry.extent);
          if (validGraphics.length > 0) {
            const extent = validGraphics.reduce((acc, graphic) => {
              return acc.union(graphic.geometry.extent);
            }, validGraphics[0].geometry.extent);
  
            const target = {
              target: extent.center, 
              zoom: this.zoom,       
            };
            this.view.goTo(target).catch(function(error) {
              console.error("Error in goTo: ", error);
            });
          } else {
            console.warn("No valid graphics available to zoom to.");
          }
        }else{
          this.view.goTo(this.pinLayer.graphics.toArray());
        }
      }else{
        this.view.goTo(this.pinLayer.graphics.toArray());
      }
    },
    drawCloses(close, closeIndex, index, closeColor, detourColor, iconColor = closeColor) {
      let _this=this;
      if (close.type=='linear') {
        let pinCloseGraph = _this.drawPinLinearClose(close, index+1, closeIndex+1, iconColor);
        let obj = {pUUID: _this.filters.uuid, 
                    elementId: close.closingId,
                    type: 'linear',
                    entry: 'closing',
                    pinCloseGraph: pinCloseGraph,
                    color: closeColor 
                  };
        _this.drawClosingPolyline(close, obj, 'closing', obj.color);
      } else {
        let typeClosing = close.dates[0].closingType[0] || 'complete';
        let obj = {pUUID: _this.filters.uuid, 
                  elementId: close.closingId, 
                  type: 'ponctuel',
                  entry: 'closing',
                  typeClosing: typeClosing,
                  color: iconColor};
        _this.drawPoint(close, index+1, closeIndex+1, obj, 'closing', obj.color);
      }
      close.detours.forEach(function(detour) {
        let obj = {pUUID: _this.filters.uuid, elementId: detour.detourId, type: 'linear', entry: 'detour', color: detourColor};
        _this.drawDetourPolyline(detour, obj, 'detour', detourColor);
      });
    },
    noticeMapGeometrySymbol(geometry, color) {
      const isGuelphPolyline = this.filters.city === 'guelph' &&
        geometry &&
        (geometry.type === 'polyline' || Array.isArray(geometry.paths));

      if (isGuelphPolyline) {
        return {
          type: "simple-line",
          style: "solid",
          color: color,
          width: 2
        };
      }

      return {
        type: "simple-fill",
        style: "none",
        outline: {
          color: color,
          width: 2
        }
      };
    },
    drawClosingPolyline(paths, obj, type, color) {
      let _this = this;
      paths.selected.path.forEach(function(object) {
        var geometry = object.geometry;
        var graph = new _this.Graphic({
            geometry   : geometry,
            attributes : object.attributes,
            visible    : true,
            symbol     : _this.noticeMapGeometrySymbol(geometry, color)
        });
        _this.phasesLayer.add(graph);
      });
      _this.phasesLayer.add(obj.pinCloseGraph);
      _this.update(paths.selected.path);
    },
    drawDetourPolyline(paths, obj, type, color) {
      let _this = this;
      let flag = (features[this.filters.city] || {}).noticeDetourArrows;
      let arrows = Boolean(flag && flag.show);
      paths.selected.path.forEach(function(object) {
        var geometry = object.geometry;
        var graph = new _this.Graphic({
            geometry   : geometry,
            attributes : object.attributes,
            visible    : !arrows,
            symbol     : _this.noticeMapGeometrySymbol(geometry, color)
        });
        _this.phasesLayer.add(graph);
      });
      if (arrows && paths.selected.path.some((object) => object.geometry && object.geometry.paths && object.geometry.paths.length)) {
        let polyline = HelpersMaps.updateSimpleLine(paths, this.Point, this.Polyline, this.geometryEngine);
        let graphs = HelpersMaps.drawRepeated(polyline, color, type, this.Polyline, this.Point, this.Graphic, this.geometryEngine, this.webMercatorUtils, this.geodesicUtils, paths.dates[0].detourSensValue);
        graphs.forEach((g) => _this.phasesLayer.add(g));
      }
    },
    populateGraph(obj, graph) {
      if (!this.graphics[obj.pUUID]) {
        this.graphics[obj.pUUID]={};
      }
      obj.graphic=graph;
      obj.ref=null;
      this.graphics[obj.pUUID][obj.elementId]=obj;
    },
    update (path) {
      var geoms, dists = [];
      geoms = path.map(function(object){
        dists.push(55);
        return object.geometry;
      });
      var buff =  this.geometryEngine.geodesicBuffer(geoms, dists, 'meters', true);
      var g = new this.Graphic({
        geometry :buff[0],
        visible : true,
        symbol  : {
          type: "simple-fill",
          style: "none",
          outline: {  
            color: '#f84c6b',
            width: 2
          }
        }
      });
      this.closingLayer.add(g);
    },
    drawPinLinearClose(close, phaseIndex, closeIndex, color) {
      let typeClosing = close.dates[0].closingType[0] || 'complete';
      let midPoint = HelpersMaps.polylineMidPoint(close, this.Point, this.Polyline, this.geometryEngine, this.webMercatorUtils);
      let symbol = HelpersDrawProject.pointClosingTypeMarker(typeClosing, color);
      let popupTemplate = this.populatePopup(close, phaseIndex, closeIndex);
      let graph = new this.Graphic({
        geometry   : midPoint,
        popupTemplate: popupTemplate,
        visible    : true,
        symbol: symbol
      });
      return graph;
    },
    drawPoint(close, phaseIndex, closeIndex, obj, type, color) {
      let graph;
      graph = HelpersDrawProject.drawPoint(close.selected.path[0], this.Graphic, type, color, this.Point, obj.typeClosing);
      let popupTemplate = this.populatePopup(close, phaseIndex, closeIndex);
      graph.popupTemplate = popupTemplate;
      this.phasesLayer.add(graph);
    },
    populatePopup(close, phaseIndex, closeIndex) {
      let content = '<strong>' + this.$i18n.t('projectForm.closeDate') + ': </strong>';
      close.dates.forEach(element => {
        let sdate = this.formatDate(element.sdate);
        let edate = this.formatDate(element.edate);
        content += '<span>' + sdate + '</span> - <span>' + edate +'</span><br/>';
      });
      content += '<strong>' + this.$i18n.t('projectForm.street') + ': </strong>' + close.value + '<br/>'
      let popupTemplate = {
        title: (this.$i18n.t('mapPage.phase') + phaseIndex) + ' ' + (this.$i18n.t('mapPage.closing') + closeIndex),
        content: content
      };
      return popupTemplate;
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },
    activeAnimation(pUUID) {
      let project = this.projects[pUUID];
      let _this=this;
      project.phases.forEach((phase) => {
        phase.closing.forEach((close) => {
          close.detours.forEach((detour)  => {
            let obj = _this.graphics[pUUID][detour.detourId];
            if (obj.animate) {
              obj.animate=false;
              _this.graphics[pUUID][detour.detourId]=obj;
              _this.detourLayer.removeMany(obj.graphic);
              _this.refs.forEach(element => {
                clearInterval(element);
              });
              _this.drawProjectsDetourPolyline(detour, obj, 'detour', obj.color);
            } else {
              obj.animate=true;
              _this.graphics[pUUID][detour.detourId]=obj;
              _this.detourLayer.removeMany(obj.graphic);
              _this.drawAnimateDetour(pUUID, detour.detourId, obj);
            }
          });
        });
      });
    },
    drawAnimateDetour(pUUID, detourId, element) {
      let _this=this;
      let project = this.projects[pUUID];
      let step = 0, i;
      let stepRev = 0;
      let options = {
        steps: 10,
        distance: 50,
        units: 'meters',
        boundMax: true
      };
      var ref, angle, graphCache = {};
      var graphCacheRev = {};
      project.phases.forEach((phase) => {
        phase.closing.forEach((close) => {
          close.detours.forEach((detour)  => {
            let detourSensValue = detour.dates[0].detourSensValue;
            if ((detour.detourId==detourId) && (element.type=='linear')) {
              if(detourSensValue == "1"){
                var obj = this.getRepeatedSymbole(detour, 'detour', element.color, options);
              }
              else if(detourSensValue == "2")
              {
                var objRev = this.getRepeatedSymboleRev(detour, 'detour', element.color, options);
              }
              else
              {
                var obj = this.getRepeatedSymbole(detour, 'detour', element.color, options);
                var objRev = this.getRepeatedSymboleRev(detour, 'detour', element.color, options);
              }
              let visible = [];

              ref = setInterval(() => {
                try {
                  _this.detourLayer.removeMany(visible);
                  if (!graphCache[step] || !graphCacheRev[stepRev]){
                    graphCache[step] = [];
                    graphCacheRev[stepRev] = [];
                    if(obj){
                      for (i = step; i < obj.slices * options.steps; i += options.steps){
                        graphCache[step].push(obj.graphs[i]);
                      }
                    }
                    if(objRev){
                      for (i = stepRev; i < objRev.slices * options.steps; i += options.steps){
                        graphCacheRev[stepRev].push(objRev.graphs[i]);
                      }
                    }
                  }
                  visible = [].concat(graphCache[step],graphCacheRev[stepRev]);
                  _this.detourLayer.addMany(visible);
                  step = (step + 1) % options.steps;
                  stepRev = (stepRev - 1) % options.steps;
                  
                  
                  element.graphic = [].concat(obj?obj.graphs:[],objRev?objRev.graphs:[]);

                 _this.graphics[pUUID][detourId] = element;
                } catch(e) {
                  console.log("error",e)
                  clearInterval(ref);
                }
              }, 80);
              element.ref=ref;
              _this.refs.push(ref);
            }
          });
        });
      });
    },
    getRepeatedSymbole(selected, type, color, options) {
      let symbol = {
        type: "simple-marker",
        style : "path",
        path : (type=='detour')?this.icons.arrowDetour:this.icons.pointClosing,
        color: color,
        size : 5,
        outline: {
          color: color,
          width: 1
        }
      };
      let pg, i, slices, percent, graphs = [];
      let polyline = HelpersMaps.updateSimpleLine(selected, this.Point, this.Polyline, this.geometryEngine);
      let fullD = this.geometryEngine.geodesicLength(polyline, options.units);
      if(fullD > (2 * options.distance)){
        slices = Math.floor(fullD / options.distance);
        if(options.boundMax && (slices >= maxSlices)){slices = maxSlices;}
      } else{slices = 2;}
      percent = 100 / (slices * options.steps);
      //("Slices ", slices, "\nPercent ", percent);
      let points = HelpersMaps.repeatedPoints(polyline, this.Point, this.geometryEngine, this.webMercatorUtils, {percent : percent, units : options.units});
      let angles = HelpersMaps.bearingAt(polyline, points, this.Polyline, this.geometryEngine, this.webMercatorUtils, this.geodesicUtils);
      for (i=0; i < angles.length; i++){
        let a = angles[i];
        symbol.angle = a.angle;
        symbol.xoffset = (Math.sign(a.angle) == -1)?"-4px":"0px",
        symbol.yoffset = (Math.sign(a.angle) == -1)?"0px":"4px",
        pg = new this.Graphic({
          geometry : a.point,
          symbol : symbol,
          
        });
        graphs.push(pg);
      }

      return {polyline : polyline, graphs: graphs, slices: slices};
    },
    getRepeatedSymboleRev(selected, type, color, options) {
      let symbol = {
        type: "simple-marker",
        style : "path",
        path : (type=='detour')?this.icons.arrowDetour:this.icons.pointClosing,
        color: color,
        size : 5,
        outline: {
          color: color,
          width: 1
        }
      };
      let pg1, i, slices, percent, graphs = [];
      let polyline = HelpersMaps.updateSimpleLine(selected, this.Point, this.Polyline, this.geometryEngine);
      let fullD = this.geometryEngine.geodesicLength(polyline, options.units);
      if(fullD > (2 * options.distance)){
        slices = Math.floor(fullD / options.distance);
        if(options.boundMax && (slices >= maxSlices)){slices = maxSlices;}
      } else{slices = 2;}
      percent = 100 / (slices * options.steps);
      //("Slices ", slices, "\nPercent ", percent);
      let points = HelpersMaps.repeatedPoints(polyline, this.Point, this.geometryEngine, this.webMercatorUtils, {percent : percent, units : options.units});
      let anglesRev = HelpersMaps.bearingAtRev(polyline, points, this.Polyline, this.geometryEngine, this.webMercatorUtils, this.geodesicUtils);
      // console.log("repeated",anglesRev);
      
      for (i=0; i < anglesRev.length; i++){
        let a = anglesRev[i];
        symbol.angle = a.angle;
        symbol.xoffset = (Math.sign(a.angle) == -1)?"0px":"4px",
        symbol.yoffset = (Math.sign(a.angle) == -1)?"-4px":"0px",
        pg1 = new this.Graphic({
          geometry : a.point,
          symbol : symbol,
          // xoffset : (Math.sign(a.angle) == -1)?"0px":"4px",
          // yoffset : (Math.sign(a.angle) == -1)?"-4px":"0px",
        });
        graphs.push(pg1);
      }
      return {polyline : polyline, graphs: graphs, slices: slices};
    },
    reportInfos(informations, lang) {
      let obj={
        'district': this.getFilterValue('district', informations.district, lang),
        'workType': this.getFilterValue('workType', informations.workType, lang),
      };
      return obj;
    },
    getFilterValue(filter, data, lang) {
      let selectedFilter = this.FiltersObject(Tags[this.filters.city][filter].value, lang);
      if (Array.isArray(data)) {
        return data.map(function(element) {
          return selectedFilter[element]; 
        }).join(', ');
      } else {
        return selectedFilter[data];
      }
    },
    FiltersObject(list, lang) {
      let obj = {};
      list.forEach((e) => {
        if (e.label_fr || e.label_en) {
          obj[e.value]=e['label_'+lang];
        } else {
          obj[e.value]=e.label;
        }
      });
      return obj;
    }
  }
};
</script>
<style>
  div.public-map  {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  div.public-map div.full-screen-map {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  div.public-map #map {
    height: 100%;
    position: relative;
  }
  div.public-map h2.esri-popup__header-title {
    color: black;
    font-weight: bold;
  }
  div.public-map span.esri-popup__icon.esri-icon-description {
    display: none;
  }
  div.public-notes > *, div.public-notes span {
    color: rgb(50, 50, 50) !important;
  }
  div.public-filters-content {
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    z-index: 9;
    display: flex;
  }
  div.filters-step-container {
    cursor: pointer;
    width: 10%;
  }
  div.filters-range {
    width: 70%;
  }
  div.filters-step-content {
    position: relative;
    top: 0;
    width: 32px;
    height: 32px;
    background-color: white;
    padding-top: 4px;
    padding-left: 4px;
    border-radius: 5px;
    display: flex;
    border: 1px solid #edeff2;
    position: absolute;
    bottom: -15px;
  }
  div.filters-step-content div.dropdown-menu.show {
    padding: 10px;
    /*width: 230px;*/
    min-width: 20rem;
  }
  div.filters-step-element {
    margin-bottom: 10px;
  }
  div.filters-step-element span.step-title {
    padding-left:10px;
  }
  /*
  span.step-title {
    background-color: white;
    padding: 7px;
    border-radius: 6px;
    border: 1px solid #edeff2;
    bottom: 2px;
    display: flex;
  }
  */
  div.loading-map {
    background: gray;
    opacity: 0.6;
  }
  div.loading-map img {
    position: absolute;
    top: 48%;
    left: 50%;
    margin-left: 20px;
  }
  div.divider {
    margin-bottom: 10px;
  }
  a.settings-icon i.tim-icons.icon-bullet-list-67 {
    font-size: 18px;
  }
  label.dropdown-title {
    font-weight: bold;
  }
  div.report-section {
    padding-top:5px;
    padding-bottom: 10px;
  }
  div.report-section a:hover,
  div.report-section a {
    cursor: pointer;
    /*color: #ba54f5;*/
    color: #1d8cf8;
    font-weight: bold;
  }
  div.documents-section p {
    color: #000;
    font-weight: bold;
    margin-bottom: 10px;
  }
  div.documents-section.hide {
    display: none;
  }
  div.documents-section.show {
    display: block;
  }
  div.documents-section a:focus,
  div.documents-section a:hover,
  div.documents-section a {
    color: #1d8cf8;
  }
  .esri-popup__navigation{
    margin: 0;
  }
  .esri-popup__inline-actions-container .esri-popup__action {
      margin-right: 30px;
  }
</style>